export default {
  TOTAL_VALUE: {
    label: 'Valor total',
    required: 1,
  },
  INVOICE_NUMBER: {
    label: 'Número da Nota Fiscal',
    required: 0,
    paired: true,
  },
  INVOICE_SERIES: {
    label: 'Serie da Nota Fiscal',
    required: 0,
    paired: true,
  },
  INVOICE_NUMBER_SERIES: {
    label: 'Serie e Número da Nota Fiscal',
    required: 0,
  },
  INVOICE_KEY: {
    label: 'Chave da Nota Fiscal',
    required: 0,
  },
  CTE_NUMBER: {
    label: 'Número do CT-e',
    required: 0,
  },
  CTE_KEY: {
    label: 'Chave CT-e',
    required: 0,
  },
  TRACKING_CODE: {
    label: 'Código de rastreio',
    required: 0,
  },
  ORDER_NUMBER: {
    label: 'Número do pedido do TMS',
    required: 0,
  },
  FREIGHT_WEIGHT_VALUE: {
    label: 'Valor frete peso',
    required: -1,
  },
  REAL_WEIGHT: {
    label: 'Peso físico',
    required: -1,
  },
  CUBIC_WEIGHT: {
    label: 'Peso cubado',
    required: -1,
  },
  GRIS: {
    label: 'Gris',
    required: -1,
    hasMultipleTypes: true,
  },
  ICMS: {
    label: 'ICMS',
    required: -1,
    hasMultipleTypes: true,
  },
  ADVALOREM: {
    label: 'Advalorem',
    required: -1,
    hasMultipleTypes: true,
  },
  ISS: {
    label: 'ISS',
    required: -1,
    hasMultipleTypes: true,
  },
  ITR: {
    label: 'ITR',
    required: -1,
    hasMultipleTypes: true,
  },
  TAS: {
    label: 'TAS',
    required: -1,
    hasMultipleTypes: false,
  },
  ADEME: {
    label: 'ADEME',
    required: -1,
    hasMultipleTypes: true,
  },
  TOLL: {
    label: 'TOLL',
    required: -1,
    hasMultipleTypes: false,
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/billing/enum/billing-tamplate-columns.enum.js